import { useFormikContext } from 'formik';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { IMaskInput } from 'react-imask';
import { FormField } from '..';
import { FormFieldPropsBase } from './fieldset.model';

interface EircodeFormFieldProps extends FormFieldPropsBase {}

export const EircodeFormField: FunctionComponent<EircodeFormFieldProps> = ({
  labelTranslationKey = '',
  placeholderTranslationKey = '',
  fieldName,
  isDisabled,
}): React.JSX.Element => {
  const { values, setFieldTouched, setFieldValue } = useFormikContext<any>();

  const handleBlur = () => {
    setFieldTouched(fieldName, true, true);
  };

  return (
    <FormField
      type="input"
      name={fieldName}
      testId={fieldName}
      labelText={t(labelTranslationKey)}
      isDisabled={isDisabled}
      render={(fieldProps) => (
        <IMaskInput
          {...fieldProps}
          mask="LDD XXXX"
          definitions={{
            L: /[A-Za-z]/,
            D: /\d/,
            X: /[A-Za-z0-9]/,
          }}
          value={values[fieldName]}
          className="c-input__input"
          name={fieldName}
          onAccept={(value) => {
            setFieldValue(fieldName, value.toUpperCase());
          }}
          disabled={isDisabled}
          placeholder={t(placeholderTranslationKey)}
          onBlurCapture={handleBlur}
          overwrite={false}
        />
      )}
    />
  );
};
